import React from "react"
import {
  BooleanInput,
  FieldProps,
  Filter,
  SearchInput,
  TextInput
} from "react-admin"

import { Workout } from "./types"

export const apiUploads = process.env.REACT_APP_API_HOST + "/uploads"

// matrix constants
export const DURATIONS = [30, 60, 120]

export const STYLES = [
  {
    key: "loose",
    label: "Loose Style"
  },
  {
    key: "max_cardio",
    label: "Max Cardio"
  },
  {
    key: "tight",
    label: "Tight Style"
  }
]

export const MAC_GROUPS = [
  {
    key: "mac12",
    label: "Mac 1 & Mac 2"
  },
  {
    key: "mac3",
    label: "Mac 3"
  }
]

export interface WorkoutProps extends FieldProps {
  source?: keyof Workout
  record?: Workout
}

export const WorkoutTitle: React.FC<WorkoutProps> = ({ record }) => (
  <>Workout: {record ? `"${record.name}"` : ""}</>
)

export const WorkoutFilter: React.FC = (props) => (
  <Filter {...props}>
    <SearchInput source="name" alwaysOn />
    <TextInput label="Filename" source="filename" alwaysOn />
    <BooleanInput label="Is enabled" source="enabled" defaultValue={true} />
  </Filter>
)

export const ShortFileField = ({ record, title }: any) => {
  if (!record) return null
  const f = record[title] || record.title || record.rawFile?.name || ""
  const short = f.length > 18 ? f.slice(0, 8) + "..." + f.slice(-7) : f
  return (
    <span
      title={f}
      style={{
        fontSize: "0.62rem",
        color: "#1565C0",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
        maxWidth: "100%"
      }}
    >
      {short || "file selected"}
    </span>
  )
}
